import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { TableCell } from '../TableCell.js';
import { TableSortButton } from '../TableSortButton.js';

var SortableHeaderCell = function (_a) {
    var label = _a.label, textAlign = _a.textAlign, order = _a.order, onClick = _a.onClick, props = __rest(_a, ["label", "textAlign", "order", "onClick"]);
    return (jsx(TableCell, __assign({ sx: { textAlign: textAlign } }, props, { children: jsx(TableSortButton, __assign({ order: order, onClick: onClick }, { children: label })) })));
};

export { SortableHeaderCell };
//# sourceMappingURL=SortableHeaderCell.js.map
